<template>
  <div  class="bg-white bd-radius-5">
    <template v-if="showCart !== 'non-slide'">
      <div class="cart-total">
        <small>
          <i class="fas fa-shopping-cart"></i>
          {{ members.length }} ชิ้น
        </small>
      </div>
    </template>
    <div
        class="bg-slider-cart py-1"
        @click="(showCart !== 'non-slide') ? $emit('openCartComponent','non-slide') : slideCart('slide')"
    >
      <i class="fas fa-chevron-left" v-if="showCart !== 'non-slide'"></i>
      <i class="fas fa-chevron-right" v-else></i>
    </div>
    <div :class="['row' , showCart !== 'non-slide' ? 'pl-4' : '']">
      <div class="col-12">
        <div class="table">
          <div class="d-flex align-items-center mt-3">
            <div class="col-1"></div>
            <div class="col-7 py-2 p-0 d-flex flex-row text-truncate align-items-center">
              <div class="pl-2">
                <h3 class="mb-0 dark">รายการสินค้า {{ sender.name }}</h3>
              </div>
            </div>
            <div class="col-4 py-2 pl-1 pr-3">
              <button class="btn btn-block py-1 px-0 btn-newbill" @click="fnCreateCashNum()">
<!--                <i class="fas fa-circle-notch fa-spin"></i>-->
                {{ members.length ? 'ยกเลิกรายการทั้งหมด' : 'เปิดบิลใหม่'
                }}
              </button>
            </div>
          </div>
          <div class="card-header border-0 dark">
            <div class="row">
              <div class="col-12">
                <b-form-group label-for="input-search-recipient" class="mt-2 mb-3 w-100">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <i class="fa fa-search text-muted"></i>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="ค้นหาพัสดุด้วยข้อมูลผู้รับ (ชื่อ, เบอร์โทร)"
                                  v-model="search"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="table-responsive scroll-bar-pop">
              <b-table
                  :items="members"
                  :fields="fields"
                  :busy="busy"
                  responsive="sm"
                  style="min-height: 450px"
              >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>

                <template slot="index" slot-scope="data">
                  <span class="text-sm">{{ data.index + 1 }}</span>
                </template>
                <!--        产品信息        -->
                <template slot="product" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType === 1">Parcel - {{row.item.detail.expressCode}}</span>
                  <span class="text-sm" v-if="row.item.orderType === 5">Goods</span>
                  <span class="text-sm" v-if="row.item.orderType === 6">Custom Service</span>
                  <br>
                  <span class="text-sm" v-if="row.item.orderType === 5">{{row.item.detail.spuName}}-{{row.item.detail.salesCount}}</span>
                  <span class="text-sm" v-if="row.item.orderType === 6">{{row.item.detail.serviceName}}</span>
                  <span class="text-sm" v-if="row.item.orderType === 1">
                    {{row.item.detail.pkgWeight}}kg
                    -
                    {{row.item.detail.pkgWidth}}cm
                    -
                    {{row.item.detail.pkgLenght}}cm
                    -
                    {{row.item.detail.pkgHeight}}cm
                  </span>
                </template>
                <!--        收件信息        -->
                <template slot="receiverInfo" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType === 1">{{row.item.detail.receiverName}}</span><br>
                  <span class="text-sm" v-if="row.item.orderType === 1">{{row.item.detail.receiverPhone}}</span>
                  <span v-if="row.item.orderType === 5 || row.item.orderType === 6">-</span>
                </template>
                <template slot="payStatus" slot-scope="row">
                  <b-badge variant="success" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 2">已支付</b-badge>
                  <b-badge variant="primary" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 1">待支付</b-badge><br>
                </template>
                <template slot="freight" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType === 1">
                    {{
                      (
                          row.item.detail.payFee -
                          row.item.detail.userCodServiceFee -
                          row.item.detail.userCodServiceTaxFee -
                          row.item.detail.userSppedServiceFee -
                          row.item.detail.userInsuranceServiceFee
                      ).toFixed(2)
                    }}

                  </span>
                  <span v-if="row.item.orderType === 5 || row.item.orderType === 6">-</span>
                </template>
                <template slot="cod" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType === 1">{{(row.item.detail.userCodServiceFee + row.item.detail.userCodServiceTaxFee).toFixed(2)}}</span>
                  <span v-if="row.item.orderType === 5 || row.item.orderType === 6">-</span>
                </template>
                <template slot="speed" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType === 1">{{row.item.detail.userSppedServiceFee}}</span>
                  <span v-if="row.item.orderType === 5 || row.item.orderType === 6">-</span>
                </template>
                <template slot="Insurance" slot-scope="row">
                  <span class="text-sm" v-if="row.item.orderType === 1">{{row.item.detail.userInsuranceServiceFee}}</span>
                  <span v-if="row.item.orderType === 5 || row.item.orderType === 6">-</span>
                </template>
                <template slot="total" slot-scope="row">
                <span class="text-sm" v-if="row.item.orderType === 1">{{row.item.detail.payFee}}</span>
                  <span v-if="row.item.orderType === 5 || row.item.orderType === 6">{{row.item.amount}}</span>
              </template>
                <template slot="manage" slot-scope="row">
                  <button
                      class="btn px-3 btn-sm btn-info"
                      v-if="row.item.detail.payStatus === 1 && row.item.orderType === 1"
                      @click="showEditPackage(row.item)"
                  >แก้ไข</button>
                  <button
                      class="btn px-3 btn-sm btn-info"
                      v-if="row.item.detail.payStatus === 1 && row.item.orderType === 5"
                      @click="showEditCommodity(row.item,2)"
                  >แก้ไข</button>
                  <button
                      class="btn px-3 btn-sm btn-info"
                      v-if="row.item.detail.payStatus === 1 && row.item.orderType === 1"
                      @click="fnDeleteExpressPkg(row.item)"
                  >删除</button>
                  <button
                      class="btn px-3 btn-sm btn-info"
                      v-if="row.item.detail.payStatus === 1 && row.item.orderType === 5"
                      @click="fnDeleteCommodity(row.item)"
                  >删除</button>
                  <button
                      class="btn px-3 btn-sm btn-info"
                      v-if="row.item.detail.payStatus === 1 && row.item.orderType === 6"
                      @click="fnDeleteServiceOrder(row.item)"
                  >删除</button>
                </template>
              </b-table>
            </div>
            <template v-if="showCart === 'non-slide'">
              <div class="col-12">
                <div class="group-result">
                  <div class="price">

                    <h6>ยอดรวมทั้งหมด
<!--                      <small>(รวมส่วนลด)</small>-->
                    </h6>
                    <h1>
                      <template>
                        <!--                          <span class="text-muted number-discount px-2">{{ total | numFormat('0,0.00') }}</span>-->
                        <!--                          <span>{{ (total - checkBill.discountAmount) | numFormat('0,0.00') }} </span>-->
                      </template>
                      <template>
                        {{ total?total:'0.00' }}
                      </template>
                      <small>บาท</small>
                    </h1>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="group-btn-etc row p-3 mt-1">
                  <div class="col-3 px-2">
                      <button class="btn btn-receipt btn-block py-3" :disabled="!isSettleMent">
                         <i class="far fa-file-alt"></i>
                        ใบเสร็จ
                      </button>
                  </div>
                  <div class="col-3 px-2" >
                      <button class="btn btn-label btn-block py-3" :disabled="!isSettleMent" @click="printCourier">
                        ใบปะหน้า
                      </button>
                  </div>
                  <div class="col-6 px-2">
                    <button type="button"
                            class="btn btn-success py-3 btn-block" :disabled="isSettleMent" @click="fnShowPayModel">
                      รับเงิน
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!--    Pay Model   -->
    <PayModel ref="showPayModel" :CASH_NUM="CASH_NUM" @fnGetPosRecentlyList="fnGetPosRecentlyList" :cashNumberInfo="cashNumberInfo"></PayModel>
    <AddCommodity @fnGetPosRecentlyList="fnGetPosRecentlyList" ref="addCommodity" :commodityInfo="commodityInfo"></AddCommodity>
  </div>
</template>
<script>
import {
  calculateOrderPayPriceByOrderIds,
  createCashNum, DeleteCommodityOrder,
  deleteExpressPkg,
  getPosRecentlyList,
  printPkgWayBillV2
} from "@/api/express";
import {cancelOrderByOne} from "@/axios/pos";
import PayModel from "@/views/Pos/components/PayModel.vue";
import member from "@/views/Member.vue";
import AddCommodity from "@/views/Pos/components/AddCommodity.vue";
import {deleteAdditionalServiceOrder} from "@/api/additionalServices";

export default{
  components: {AddCommodity, PayModel},
  props:{
    showCart:{
      type:String,
      default:'',
    },
    CASH_NUM:{
      type:String,
      default:'',
    },
    sender:{
      type:Object,
      default:() => {},
    },
    cashNumberInfo:{
      type:Object,
      default:() => {},
    },
    members:{
      type:Array,
      default:() => [],
    },
    total:{
      type:Number,
      default:'',
    },
    isSettleMent:{
      type:Boolean,
      default:'',
    },
    cashInfo:{
      type:Object,
      default:() => {},
    },

  },
  data(){
    return {
      search:'',
      busy:false,
      fields: [
        { key: "index", label: "#"},
        { key: "product", label: "产品信息"},
        { key: "receiverInfo", label: "收件信息" },
        { key: "payStatus", label: "支付状态" },
        { key: "freight", label: "运费" },
        { key: "cod", label: "COD" },
        { key: "speed", label: "SPEED" },
        { key: "Insurance", label: "Insurance" },
        { key: "total", label: "总价" },
        { key: "manage", label: "การจัดการ", sortable: false }
      ],
      // 支付前折扣
      speDiscountType: 1,
      userDiscountId: '',
      speFrightDiscount: '',
      payData:{},
      commodityInfo:{}
    }
  },
  created(){
  },
  methods:{
    deleteExpressPkg,
    showEditPackage(item){
      if (item){
        this.$emit('showAddReceiverInfo',item)
      }else{
        this.$emit('showAddReceiverInfo')
      }
    },
    showEditCommodity(item,type){
      this.commodityInfo = item.detail
      this.$refs.addCommodity.showCommodityModel(item.detail,type)
    },
    // 创建收银任务
    fnCreateCashNum(){
      this.$emit('fnCreateCashNum')
    },
    slideCart(key) {
      return this.$emit('slideCart', key)
    },
    fnGetPosRecentlyList(){
      this.$emit('fnGetPosRecentlyList')
    },
    // 支付前计算价格
    fnShowPayModel(){
      this.busy= true
      let orderIds = this.cashNumberInfo.detail
          .filter((item) => item.orderType === 5 && item.payStatus === 1)
          .map((item) => item.orderId)
      let pkgIds = this.cashNumberInfo.detail
          .filter((item) => item.orderType === 1 && item.payStatus === 1)
          .map((item) => item.orderId)
      let servicesIds = this.cashNumberInfo.detail
          .filter((item) => item.orderType === 6 && item.payStatus === 1)
          .map((item) => item.orderId)
      let params = {
        orderIds: orderIds,
        pkgIds: pkgIds,
        servicesIds:servicesIds
      }
      calculateOrderPayPriceByOrderIds(params)
          .then((res) => {
            this.payData = {
              ...res.data,
              ...params
            }
            this.busy= false
            this.$refs.showPayModel.showPayModel(this.payData)
          })
    },
    printCourier(){
      let pkgIds = this.members.filter(item => item.orderType === 1 && item.payStatus === 2).map((item) => item.orderId)
      printPkgWayBillV2(pkgIds)
          .then((res) => {
            window.open(res.data.url)
          })
    },
    fnDeleteExpressPkg(item){
      this.$bvModal
          .msgBoxConfirm('是否确认删除？', {
            title: "กรุณายืนยัน",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "ยืนยัน",
            cancelTitle: "ยกเลิก",
            contentClass: "modal-confirm",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            deleteExpressPkg({pkgId: item.orderId})
                .then((res) => {
                  console.log(res)
                  this.fnGetPosRecentlyList()
                })
          })
          .catch(err => {
            // An error occurred
          })
    },
    fnDeleteCommodity(item){
      this.$bvModal
          .msgBoxConfirm('是否确认删除？', {
            title: "กรุณายืนยัน",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "ยืนยัน",
            cancelTitle: "ยกเลิก",
            contentClass: "modal-confirm",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            DeleteCommodityOrder(item.orderId)
                .then((res) => {
                  console.log(res)
                  this.fnGetPosRecentlyList()
                })
          })
          .catch(err => {
            // An error occurred
          })
    },
    fnDeleteServiceOrder(item){
      this.$bvModal
          .msgBoxConfirm('是否确认删除？', {
            title: "กรุณายืนยัน",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "ยืนยัน",
            cancelTitle: "ยกเลิก",
            contentClass: "modal-confirm",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            deleteAdditionalServiceOrder(item.orderId)
                .then((res) => {
                  console.log(res)
                  this.fnGetPosRecentlyList()
                })
          })
          .catch(err => {
            // An error occurred
          })
    },
  }
}
</script>
